import { useRef } from "react";
import type { RatingWithEffectiveDebits } from "../../types";
import { Alert } from "../Alert";
import { Button } from "../Button";
import { ModalShell } from "../ModalShell";

interface AuroraModalProps {
  ratings: readonly RatingWithEffectiveDebits[];
  onContinue: () => void;
  onCancel: () => void;
  children?: never;
}

/** Placeholder for the SRx carve-out walkthrough (product plan 4.13): drug table and trigger only; the math is pending actuarial. */
export function AuroraModal({ ratings, onContinue, onCancel }: AuroraModalProps) {
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <ModalShell
      title="Specialty Rx carve-out"
      description="This group has the SRx carve-out and a selected drug is on the Aurora list."
      onClose={onCancel}
      initialFocusRef={cancelRef}
      size="sm"
      footer={
        <>
          <Button ref={cancelRef} variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onContinue}>Continue</Button>
        </>
      }
    >
      <ul className="mb-4 space-y-2">
        {ratings.map((rating) => (
          <li key={rating.ratingId} className="flex items-center justify-between rounded-lg border border-gray-200 px-3 py-2 text-sm">
            <span className="font-medium text-gray-800">{rating.specialtyDrug?.drugName ?? rating.ratingText}</span>
            <span className={rating.specialtyDrug?.isPapEligible ? "text-success" : "text-gray-500"}>{rating.specialtyDrug?.isPapEligible ? "PAP eligible" : "Not PAP eligible"}</span>
          </li>
        ))}
      </ul>
      <Alert type="warning" message="Aurora math to be defined by actuarial. The rating will be added with its catalog debits for now." />
    </ModalShell>
  );
}
